import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ScrollToHash from "@/components/site/ScrollToHash";
import ScrollReveal from "@/components/site/ScrollReveal";
import ChatWidget from "@/components/site/ChatWidget";

const GalleryPage = lazy(() => import("@/pages/GalleryPage"));
const BuildsPage = lazy(() => import("@/pages/BuildsPage"));
const MajesticPage = lazy(() => import("@/pages/MajesticPage"));
const FountainRepairPage = lazy(() => import("@/pages/FountainRepairPage"));
const AvailableNowPage = lazy(() => import("@/pages/AvailableNowPage"));
const PiecePage = lazy(() => import("@/pages/PiecePage"));
const LeadsDashboard = lazy(() => import("@/pages/LeadsDashboard"));

export const TOAST_OPTIONS = {
  style: {
    fontFamily: "Outfit, sans-serif",
    background: "#1F1E1C",
    color: "#F9F6F0",
    border: "1px solid #9D8462",
    borderRadius: 0,
  },
};

export const AppRoutes = () => (
  <Suspense fallback={null}>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/builds" element={<BuildsPage />} />
      <Route path="/majestic" element={<MajesticPage />} />
      <Route path="/fountain-repair" element={<FountainRepairPage />} />
      <Route path="/available-now" element={<AvailableNowPage />} />
      <Route path="/bird-baths" element={<Navigate to="/available-now" replace />} />
      <Route path="/piece/:slug" element={<PiecePage />} />
      <Route path="/leads" element={<LeadsDashboard />} />
    </Routes>
  </Suspense>
);

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" toastOptions={TOAST_OPTIONS} />
      <BrowserRouter>
        <ScrollToHash />
        <ScrollReveal />
        <AppRoutes />
      </BrowserRouter>
      <ChatWidget />
    </div>
  );
}

export default App;
